import {action, computed, observable, makeObservable} from 'mobx';
import {Field} from '../../Common/stores/Field';
import {TemplateCollection} from './TemplateCollection';

export class TemplateField extends Field {
    // Word Templates variables
    @observable readOnly;

    //isActive: when user clicks on download and edit the field is Active until a new file is uploaded to the field
    // @ts-ignore
    filepath;
    filetime;
    template;
    isOld;
    isPredefined;
    @observable lang: string;
    @observable isActiveField;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.readOnly = field.readonly;
        this.filepath = field.filepath ? field.filepath : '';
        this.filetime = field.filetime ? field.filetime : '';
        this.template = field.template;
        this.isOld = field.isOld;
        this.isPredefined = field.isPredefined;
        this.lang = field.lang;
        this.isActiveField = false;
        this.collection = new TemplateCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    @action setActive(isActive) {
        this.isActiveField = isActive;
    }

    @action setReadOnly(readOnly) {
        this.readOnly = readOnly;
    }

    setLang(lang: string) {
        this.lang = lang;
    }

    @computed get isDefaultTemplate() {
        return this.template > -100 && this.template !== -1;
    }

    @computed get isNewTemplate() {
        return this.template === -1;
    }

    @computed get isTemplate() {
        return this.template !== undefined && this.readOnly !== undefined;
    }

    @action setData(row, dataTables?) {
        const setDataRowItemJs = (window as any).setDataRowItemJs;
        setDataRowItemJs(row, 'pos', this.pos);
        setDataRowItemJs(row, 'title', this.title);
        setDataRowItemJs(row, 'hidden', this.hiddenStatus + '');
    }
}
